/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import { itemlist } from 'menu-items/itemlist';

const MenuList = () => {
    const customization = useSelector((state) => state.customization); // Use hook inside component
    //console.log('customization', customization);

    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const fetchItems = () => {
            try {
                const response = itemlist(customization); // Pass customization as an argument
                //console.log('response in menulist', response);
                setMenuItems(response?.items || []);
            } catch (error) {
                console.error('Error fetching menu items:', error);
            }
        };

        fetchItems();
    }, [customization]); // Re-run effect when customization changes

    const navItems = menuItems?.map((item) => {
        switch (item?.type) {
            case 'group':
                return <NavGroup key={item?.id} item={item} />;
            case 'collapse':
                return <NavCollapse key={item?.id} menu={item} level={1} />;
            case 'item':
                return <NavItem item={item} level={1} key={item?.id} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        MenuList Menu Items Error
                    </Typography>
                );
        }
    });

    return <div style={{ marginTop: '10px' }}>{navItems}</div>;
};

export default MenuList;

// // material-ui
// import { Typography } from '@mui/material';

// // project imports
// import NavGroup from './NavGroup';
// import { itemlist } from 'menu-items/itemlist';
// import { useState, useEffect } from 'react';
// import NavCollapse from './NavCollapse';
// import NavItem from './NavItem';
// import { useSelector } from 'react-redux';

// // ==============================|| SIDEBAR MENU LIST ||============================== //

// const MenuList = () => {
//     const customization = useSelector((state) => state.customization);
//     console.log('customization', customization);
//     const [menuItems, setMenuItems] = useState([]);

//     useEffect(() => {
//         const fetchItems = async () => {
//             try {
//                 const response = itemlist();
//                 console.log('response in menulist', response);

//                 setMenuItems(response?.items || []); // Ensure menuItems is always an array
//             } catch (error) {
//                 console.error('Error fetching menu items:', error);
//             }
//         };

//         fetchItems();
//     }, []);
//     console.log('menuItems', menuItems);

//     const navItems = menuItems?.map((item) => {
//         switch (item?.type) {
//             case 'group': //case 'group'
//                 return <NavGroup key={item?.id} item={item} />;
//             case 'collapse':
//                 return <NavCollapse key={item?.id} menu={item} level={1} />;
//             case 'item':
//                 return <NavItem item={item} level={1} />;
//             default:
//                 return (
//                     <Typography key={item.id} variant="h6" color="error" align="center">
//                         MenuList Menu Items Error
//                     </Typography>
//                 );
//         }
//     });

//     return <div style={{ marginTop: '10px' }}>{navItems}</div>;
// };

// export default MenuList;
